/** =========================================================
 * System controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-system')
    .controller('SystemController', SystemController);

  SystemController.$inject = [
    '$rootScope',
    '$scope',
    '$api',
    '$state',
    'MainPreloader'
  ];

  function SystemController(
    $rootScope,
    $scope,
    $api,
    $state,
    MainPreloader
  ) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.init = false;
    vm.errors = null;
    vm.cache = null;
    vm.replayPath = '';
    vm.replayBody = '';
    vm.replayResponse = null;

    activate();

    // //////////////

    function activate() {
      vm.init = true;

      vm.getErrors = function () {
        MainPreloader.show();

        return $api.get({
          path: '/api/system/errors'
        }).then(function (response) {
          vm.errors = response.data;
        }).then(MainPreloader.hide, function (error) {
          MainPreloader.hide();

          Raven.captureException(error);
        });
      };

      vm.clearErrors = function () {
        MainPreloader.show();

        return $api.post({
          path: '/api/system/errors'
        }).then(vm.getErrors, function (error) {
          MainPreloader.hide();

          Raven.captureException(error);
        });
      };

      vm.getCache = function () {
        MainPreloader.show();

        return $api.get({
          path: '/api/system/cache'
        }).then(function (response) {
          vm.cache = response.data;
        }).then(MainPreloader.hide, function (error) {
          MainPreloader.hide();

          Raven.captureException(error);
        });
      };

      vm.clearCache = function () {
        MainPreloader.show();

        return $api.post({
          path: '/api/system/cache'
        }).then(vm.getCache, function (error) {
          MainPreloader.hide();

          Raven.captureException(error);
        });
      };

      vm.replay = function () {
        MainPreloader.show();
        vm.replayResponse = null;

        return $api.post({
          path: vm.replayPath || '',
          data: vm.replayBody ? JSON.parse(vm.replayBody) : null
        }).then(function (response) {
          MainPreloader.hide();

          vm.replayResponse = JSON.stringify(response.data || '', undefined, 2);
        }, function (error) {
          MainPreloader.hide();

          vm.replayResponse = JSON.stringify(error || '', undefined, 2);
        });
      };

      vm.getErrors();
      vm.getCache();
    }
  }
})();
